import { render, staticRenderFns } from "./j-list.vue?vue&type=template&id=110a1686&scoped=true&"
import script from "./j-list.vue?vue&type=script&lang=js&"
export * from "./j-list.vue?vue&type=script&lang=js&"
import style0 from "./j-list.vue?vue&type=style&index=0&id=110a1686&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110a1686",
  null
  
)

export default component.exports